<app-dialog-header headerIcon="webhook" *ngIf="dialogForm.get('WebhookID')?.value == 0"
	headerText="Add {{dialogForm.get('Type')?.value}} Integration" (onCloseClick)="onCancelClick()"></app-dialog-header>
<app-dialog-header headerIcon="webhook" *ngIf="dialogForm.get('WebhookID')?.value != 0"
	headerText="Modify {{dialogForm.get('Type')?.value}} Integration"
	(onCloseClick)="onCancelClick()"></app-dialog-header>

<form [formGroup]="dialogForm">
	<div mat-dialog-content style="min-width: 500px;">
		<mat-form-field>
			<mat-label>Integration ID:</mat-label>
			<input matInput autocomplete="off" readonly formControlName="WebhookUID" required>
			<mat-error *ngIf="dialogForm.get('WebhookUID')!.hasError('required')">WebhookUID is required</mat-error>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Description:</mat-label>
			<input matInput autocomplete="off" formControlName="Description">
			<mat-error *ngIf="dialogForm.get('Description')!.hasError('required')">Description is required</mat-error>
		</mat-form-field>
		<mat-form-field>
			<mat-label>ClientWebhook ID: (Device Name/Serial Number)</mat-label>
			<input matInput autocomplete="off" formControlName="ClientWebhookID" required>
			<mat-error *ngIf="dialogForm.get('ClientWebhookID')!.hasError('required')">ClientWebhookID is
				required</mat-error>
		</mat-form-field>
		<div
			style="font-size: 12px;margin:5px 0 5px 0;padding:10px;border:1px solid #ccc;border-radius:5px;background-color:#f9f9f9;">
			<table style="width: 100%;">
				<colgroup>
					<col style="width: 100px;"> <!-- First column: Image -->
					<col style="width: Auto;"> <!-- Second column: Text content -->
					<col style="width: 30px;"> <!-- Fourth column: Text content -->
				</colgroup>
				<tbody>
					<tr>
						<th style="vertical-align: top;">Host URL:</th>
						<td style="max-width: 300px; word-break: break-all;">
							<span>{{dialogForm.get('FQN')?.value}}</span>
						</td>
						<td >
							<span class="app-icon app-icon--copy" mat-icon-button (click)="copyFQNToClipboard()"
								matTooltip="Copy FQN For the Webhook Address"
								matTooltipPosition="left">
								<mat-icon />
							</span>
						</td>
					</tr>
					<!-- <tr>
						<th>Path:</th>
						<td>{{dialogForm.get('Path')?.value}}</td>
					</tr>
					<tr *ngIf="dialogForm.get('TypeAzureCode')?.value != ''">
						<th>Azure Code:</th>
						<td>{{dialogForm.get('TypeAzureCode')?.value}}</td>
					</tr> -->
					<tr>
						<th colspan="3" style="vertical-align: top;">HTTP Headers:</th>
					</tr>
					<tr>
						<th>AccountUID:</th>
						<td>{{dialogForm.get('AccountUID')?.value}}</td>
						<td>
							<span class="app-icon app-icon--copy" mat-icon-button
								(click)="copyToClipboard(dialogForm.get('AccountUID')?.value)"
								matTooltip="Copy header AccountUID"
								matTooltipPosition="left">
								<mat-icon />
							</span>
						</td>
					</tr>
					<tr>
						<th>OrganisationUID:</th>
						<td style="text-align: left;">{{dialogForm.get('OrganisationUID')?.value}}</td>
						<td>
							<span class="app-icon app-icon--copy" mat-icon-button
								(click)="copyToClipboard(dialogForm.get('OrganisationUID')?.value)"
								matTooltip="Copy header OrganisationUID"
								matTooltipPosition="left">
								<mat-icon />
							</span>
						</td>
					</tr>
					<tr>
						<th>ClientWebhookID:</th>
						<td>{{dialogForm.get('ClientWebhookID')?.value}}</td>
						<td>
							<span class="app-icon app-icon--copy" mat-icon-button
								(click)="copyToClipboard(dialogForm.get('ClientWebhookID')?.value)"
								matTooltip="Copy header ClientWebhookID"
								matTooltipPosition="left">
								<mat-icon />
							</span>
						</td>
					</tr>
					<tr>
						<th>Content-Type:</th>
						<td>application/json</td>
						<td>
							<span class="app-icon app-icon--copy" mat-icon-button (click)="copyToClipboard('application/json')"
								matTooltip="Copy header Content-Type"
								matTooltipPosition="left">
								<mat-icon />
							</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="md-form mb-1 matFormSlider">
			<div>
				<mat-label>AutoBuild:</mat-label>
				<mat-slide-toggle #switchAutoBuild formControlName="AutoBuild" color="primary"></mat-slide-toggle>
			</div>
		</div>
		<div class="md-form mb-1 matFormSlider">
			<div>
				<mat-label>Enabled:</mat-label>
				<mat-slide-toggle #switchEnabled formControlName="Enabled" color="primary"></mat-slide-toggle>
			</div>
		</div>
	</div>
	<div mat-dialog-actions>
		<button mat-button [mat-dialog-close]="dialogForm.value"
			[disabled]="dialogForm.invalid || !dialogForm.dirty">Ok</button>
		<button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
	</div>
</form>